import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { BaseEntityService } from "../rest-common.service";
import { NotificationService } from "src/app/notification.service";
import { AssetLibraryItem, AssetTypeLimit } from "src/app/models/dco/library";

@Injectable({
  providedIn: "root",
})
export class DcoLibraryService extends BaseEntityService {
  public resource_url = `${this.BASE_DCO_URL}/asset-library/`;

  constructor(public http: HttpClient, public toastr: NotificationService) {
    super();
  }
  
  getAssetList(params: any = {}): Observable<any> {
    const url = this.buildUrl(this.resource_url, "", params);
    return this.get(url);
  }

  getAssetLimit(params: any = {}): Observable<any> {
    const url = this.buildUrl(`${this.BASE_DCO_URL}/asset-library/asset-limits`, "", params);
    return this.get(url);
  }
}
